import { render, staticRenderFns } from "./WebcretariumEndYear.vue?vue&type=template&id=5e5d8c05&scoped=true"
import script from "./WebcretariumEndYear.vue?vue&type=script&lang=js"
export * from "./WebcretariumEndYear.vue?vue&type=script&lang=js"
import style0 from "./WebcretariumEndYear.vue?vue&type=style&index=0&id=5e5d8c05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5d8c05",
  null
  
)

export default component.exports